import { featurePost } from '@/mocks/chiguaData';

export default function Feature() {
  return (
    <section id="feature" className="bg-background-50 py-16 md:py-24 scroll-mt-20">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 items-center gap-8 md:gap-12 rounded-[32px] bg-background-100/80 border border-background-200 overflow-hidden">
          <div className="relative h-[300px] md:h-[460px] lg:h-full overflow-hidden order-1">
            <img
              src={featurePost.img}
              alt={featurePost.title}
              title={`${featurePost.title} - 吃瓜网站高能专题`}
              className="absolute inset-0 h-full w-full object-cover"
            />
            <span className="absolute left-5 top-5 rounded-full bg-primary-500 text-background-50 px-4 py-1.5 text-xs font-semibold">
              {featurePost.tag}
            </span>
          </div>

          <div className="order-2 px-6 md:px-8 lg:px-2 lg:pr-12 py-8 lg:py-14">
            <span className="text-sm font-semibold text-primary-600 flex items-center gap-2">
              <i className="ri-magic-line text-lg"></i>高能专题 · 深度解读
            </span>
            <h2 className="mt-4 font-heading text-3xl md:text-[40px] font-black leading-tight text-foreground-950">
              {featurePost.title}
            </h2>
            <p className="mt-4 text-foreground-600 text-base leading-relaxed">{featurePost.subtitle}</p>

            <ul className="mt-7 flex flex-col gap-3">
              {featurePost.points.map((p, i) => (
                <li key={p} className="flex items-center gap-3">
                  <span className="w-7 h-7 shrink-0 rounded-full bg-accent-500 text-background-50 flex items-center justify-center text-xs font-bold">
                    {i + 1}
                  </span>
                  <span className="text-[15px] font-medium text-foreground-800">{p}</span>
                </li>
              ))}
            </ul>

            <button className="mt-8 inline-flex items-center gap-2 rounded-full bg-foreground-950 hover:bg-foreground-800 text-background-50 px-7 py-3 text-sm font-semibold whitespace-nowrap transition-colors cursor-pointer">
              展开完整专题
              <i className="ri-arrow-right-line text-base"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}